import { isEditMode } from '../../utils';
import validate from '../../validations';

export default {
  refreshOn: ({ selectedTabId }) => ([selectedTabId]),
  init: ({ selectedTabId, photoIDs }, stateManager) => {
    stateManager.setLastActiveScreen(selectedTabId || '');
    if(selectedTabId == 'review') {
      if(isEditMode()) return;
      const validated = photoIDs.map(photo => {
        if (photo.docID) return { ...photo, hasError: false }
        return { ...photo, docIDError: "Please upload photo ID", hasError: true }
      })
      stateManager.set({ photoIDs: validated })
    }

    validate();
  },
  'PageTabs.Wrapper.TabsFilter.Tab': ({ tab }, stateManager) => {
    stateManager.setSelectedTabId(tab.id);
  }
};
